import React from 'react';
import Popover from '@mui/material/Popover';

interface NotificationPopoverProps {
  id: string;
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: React.ReactNode;
}

const NotificationPopover: React.FC<NotificationPopoverProps> = ({
  id,
  open,
  anchorEl,
  onClose,
  children,
}) => {
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      sx={{
        minWidth: '250px',
      }}
    >
      {children}
    </Popover>
  );
};

export default NotificationPopover;
